import React from "react";
import ContactSection from "../../components/ContactSection";
import InnerBanner from "../../components/InnerBanner";
// import LocationArea from "../../components/LocationArea";

const Contact = () => {
  return (
    <>
      <InnerBanner title="Contact Us"/>
      {/* <LocationArea/> */}
      <ContactSection/>
    </>
  );
};

export default Contact;
